module.exports = __webpack_public_path__ + "static/media/PreRegistration.b061cf67.png";